import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';
import {
  EntitlementsInterfaceType,
  OfferingAndEntitlementType,
  OfferingAndEntitlementOptionsType,
  RefreshType
} from './types';
import { IEntitlementsService } from '../../../services/entitlementsService';
import {
  EntitlementsListType,
  SubscriptionOfferingListType
} from '../../../clients/stratus/entitlements/getProgramInfo/types';

export class EntitlementsInterfaceV1 {
  private entitlementsService: IEntitlementsService;

  constructor() {
    const services = getServices();
    this.entitlementsService = services.entitlementsService;

    bindAllMethods(this);
  }

  getInterface(): EntitlementsInterfaceType {
    return {
      refresh: this.refresh,
      checkEntitlements: this.checkEntitlements,
      checkOfferings: this.checkOfferings,
      getPlanInfo: this.getPlanInfo,
      getOffering: this.getOffering,
      getEntitlement: this.getEntitlement
    };
  }

  private async refresh(
    refreshOption?: RefreshType,
    options?: OfferingAndEntitlementOptionsType
  ): Promise<void> {
    return this.entitlementsService.refresh(refreshOption, options);
  }

  private async checkEntitlements(
    entitlements: OfferingAndEntitlementType[],
    options?: OfferingAndEntitlementOptionsType
  ): Promise<boolean> {
    return this.entitlementsService.checkEntitlements(entitlements, options);
  }

  private async checkOfferings(
    offerings: OfferingAndEntitlementType[],
    options?: OfferingAndEntitlementOptionsType
  ): Promise<boolean> {
    return this.entitlementsService.checkOfferings(offerings, options);
  }

  private async getPlanInfo(
    options?: OfferingAndEntitlementOptionsType
  ): Promise<any> {
    return this.entitlementsService.getPlanInfo(options);
  }

  private async getOffering(
    serviceId: string,
    options?: OfferingAndEntitlementOptionsType
  ): Promise<SubscriptionOfferingListType> {
    return this.entitlementsService.getOffering(serviceId, options);
  }

  private async getEntitlement(
    serviceId: string,
    options?: OfferingAndEntitlementOptionsType
  ): Promise<EntitlementsListType> {
    return this.entitlementsService.getEntitlement(serviceId, options);
  }
}
